/**
 * THE PIECES' CHARACTERS, CENTRED BY THEIR INK — owner, 2026-10-20 (a screenshot from his iPhone): 這個文字在象棋的圈圈
 * 上面跑掉了, 應該把它放到中間才對.
 *
 * The board first put each character on `dominant-baseline: central`, which asks the browser where the middle of the
 * FONT is. Chrome answers from the font that drew the glyph; WebKit answers from the first font of the list it has —
 * on an iPhone none of the Chinese faces named below is installed, so it measured a Latin font while the character
 * came from a fallback Chinese one, and the character sat off the middle of its disc (high on his phone, low in
 * WebKit here). The alphabetic baseline is the one every engine places the same, so each character is measured once,
 * in this browser, with the same font, and set on that baseline by its own ink.
 */

export const HAN_FONT = "'Noto Serif TC', 'Noto Serif CJK TC', 'Songti TC', STSong, PMingLiU, serif"

/** A Chinese face's usual drop, where nothing can be measured (a test's DOM has no canvas). */
const TYPICAL_DROP = 0.37
const drops = new Map<string, number>()

/** How far below the middle of `text`'s ink its alphabetic baseline lies, as a fraction of the font size. */
export function inkDrop(text: string, weight = 400): number {
  const key = `${weight}|${text}`
  const known = drops.get(key)
  if (known !== undefined) return known
  let drop = TYPICAL_DROP
  if (typeof navigator === 'undefined' || !/jsdom/i.test(navigator.userAgent)) {
    try {
      const g = document.createElement('canvas').getContext('2d')
      if (g) {
        g.font = `${weight} 100px ${HAN_FONT}`
        const m = g.measureText(text)
        if (m.actualBoundingBoxAscent + m.actualBoundingBoxDescent > 0) {
          drop = (m.actualBoundingBoxAscent - m.actualBoundingBoxDescent) / 200
        }
      }
    } catch {
      /* the typical drop stands */
    }
  }
  drops.set(key, drop)
  return drop
}
